import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, } from "react-bootstrap";
import { FaPrint, FaRegCircleCheck } from "react-icons/fa6";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { FaDownload, FaWindowClose, } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CONTEXT_NAME } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import BasePaymentStatus from "../Posts/BasePaymentStatus";

export default function TetPaymentStatus() {
    // let location = useLocation();
    // let query = new URLSearchParams(location?.search);
    // let componentRef = useRef();
    // const handleprint = useReactToPrint({
    //     content: () => componentRef.current,
    //     documentTitle: "college-data",
    // });
    // console.log("query>>", query);
    // const status = query.get('status');
    // const trId = query.get('tpsltxnid');
    // let navigate = useNavigate();
    // const [modalStatus, setModalStatus] = useState(false);
    // const [modalText, setModalText] = useState("");
    // function getdata() {
    //     console.log("inside getdata api");
    //     let Url = config.url.CONTEXT_READ_URL + "tet-payment-invoice-details?tpslTxnId=" + trId
    //     CommonAxiosGet(Url).then((res) => {
    //         if (res?.data?.status === true && res?.data?.scode === "01") {
    //             let data = res?.data?.data;
    //             console.log("res>>", data);
    //             let showData = data[0];
    //             const paymentContent = status === "SUCCESS" ? (
    //                 <>
    //                     <div ref={componentRef}>
    //                         <div className="payment-success">
    //                             <h2 className="success-message fadeInUp">
    //                                 <FaRegCircleCheck />  &nbsp;
    //                                 Payment Successful!

    //                             </h2>
    //                         </div>
    //                         <div className="table-responsive mb-3 px-3">
    //                             <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0" role="presentation"
    //                                 style={{ borderCollapse: 'collapse', background: "#a5820726" }}>
    //                                 <thead>
    //                                     <tr>
    //                                         <td>Candidate ID</td>
    //                                         <th>{showData?.candidate_id}</th></tr>
    //                                     <tr>
    //                                         <td>Candidate Name</td>
    //                                         <th>{showData?.applicant_name}</th></tr>
    //                                     <tr>
    //                                         <td>Transaction Id</td>
    //                                         <th>{showData?.tpsl_txn_id}</th></tr>
    //                                     <tr>
    //                                         <td>CFSS Transaction Id</td>
    //                                         <th>{showData?.cfss_txn_id}</th></tr>
    //                                     <tr>
    //                                         <td>Paid Amount</td>
    //                                         <th>{showData?.amount}</th></tr>
    //                                     <tr>
    //                                         <td>Paid Date</td>
    //                                         <th>{new Date(showData?.time_stamp).toLocaleString()}</th></tr>
    //                                     <tr>
    //                                         <td>Payment Status</td>
    //                                         <th>{showData?.status}</th></tr>

    //                                 </thead>
    //                                 <tfoot><tr>
    //                                     <td colSpan={2} className="text-end">
    //                                         <button type="button" className="btn btn-link" onClick={handleprint} >
    //                                             <FaDownload title="download invoice" style={{ fontSize: '22px' }} /></button>
    //                                     </td>
    //                                 </tr>
    //                                 </tfoot>
    //                             </table>
    //                         </div>
    //                     </div>
    //                     <table style={{ margin: "0 auto", width: "90%" }} role="presentation">
    //                         <thead>
    //                             <tr>
    //                                 <td colSpan={3} className="text-center"> <h5 onClick={() => { navigate('/TetPrintApplication') }} onKeyDown={(e) => {
    //                                     if (e.key === 'Enter' || e.key === ' ') {
    //                                         e.preventDefault();
    //                                         navigate('/TetPrintApplication')
    //                                     }
    //                                 }} >
    //                                     <button className="btn btn-secondary" variant="primary">Print Application &nbsp;
    //                                         <FaPrint title="Print" style={{ fontSize: '22px' }} />
    //                                     </button>
    //                                 </h5></td>
    //                                 <td></td>
    //                             </tr>
    //                         </thead>
    //                     </table>
    //                 </>
    //             ) : (
    //                 <>
    //                     <h3 className="text-danger text-center pt-5">
    //                         <HiOutlineExclamationCircle size={32} />&nbsp;Payment Failed, Please try again.
    //                         <i className="badge badge-success forgot mb-2 fw-bold"
    //                             onClick={() => { navigate('/PaperApplication') }}
    //                             onKeyDown={(e) => {
    //                                 if (e.key === 'Enter' || e.key === ' ') {
    //                                     e.preventDefault();
    //                                     navigate('/PaperApplication')
    //                                 }
    //                             }}
    //                             data-toggle="tooltip" animation="true" title="Click Me!"
    //                         > Click Here</i>
    //                     </h3>
    //                 </>
    //             );
    //             setModalText(paymentContent);
    //             setModalStatus(true);
    //         }
    //     })
    // }
    // useEffect(() => {
    //     if (status === "SUCCESS") {
    //         console.log("status>>", status);
    //         getdata()
    //     }
    //     else {
    //         let failureContent = (<>
    //             <h3 className="text-danger text-center pt-5">
    //                 <HiOutlineExclamationCircle size={32} />&nbsp;Payment Failed, Please try again.
    //                 <i className="badge badge-success forgot mb-2 fw-bold"
    //                     onClick={() => { navigate('/PaperApplication') }} onKeyDown={(e) => {
    //                         if (e.key === 'Enter' || e.key === ' ') {
    //                             e.preventDefault();
    //                             navigate('/PaperApplication')
    //                         }
    //                     }}
    //                     data-toggle="tooltip" animation="true" title="Click Me!"
    //                 > Click Here</i>
    //             </h3>
    //         </>);
    //         setModalText(failureContent);
    //         setModalStatus(true);
    //     }

    // }, [trId, status]);

    // const closeModal = () => {
    //     if (status === 'SUCCESS') {
    //         navigate('/TetPrintApplication')
    //     }
    //     else {
    //         navigate('/PaperApplication')
    //     }

    //     setModalStatus(false);
    // };
    const url = config.url.CONTEXT_URL + "tet-payment-invoice-details?tpslTxnId=";

    return (
        <React.Fragment>
            <BasePaymentStatus apiUrl={url} showNote={false} successNavigatePath="/TetPrintApplication"
                failureNavigatePath="/PaperApplication" />
        </React.Fragment>
    )
}